import hosLayout from './components/dialog-hospitalization.vue';
import hosCard from './components/card-hospitalization.vue';
import hosTag from './components/tags-hospitalization.vue';
import hosBeds from './components/dialog-hosipitalizationBeds.vue';
import bedSelector from './components/dialog-bedSelector.vue';

const components = [hosLayout, hosCard, hosTag, hosBeds, bedSelector];

const install = function (Vue) {
  if (install.installed) return;

  install.installed = true;

  components.forEach((com) => {
    Vue.component(com.name, com);
  });
};

export default {
  install,
  ...components,
};
